module.exports = __webpack_public_path__ + "img/invision_logo_pink.e3504932.svg";